import { render } from "./ConfirmationPopUp.vue?vue&type=template&id=8aaa2a2a&scoped=true"
import script from "./ConfirmationPopUp.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopUp.vue?vue&type=script&lang=js"

import "./ConfirmationPopUp.vue?vue&type=style&index=0&id=8aaa2a2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8aaa2a2a"

export default script